import { useEffect } from 'react';
import { ClientsSelectors } from '@/store/slices/clients';
import { useAppDispatch, useAppSelector } from '@/store/StoreHooks';
import { fetchClientList } from '@/store/thunk/clients';

export default function useAllClientList() {
  const clientsList = useAppSelector(ClientsSelectors.clientsListSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!clientsList) {
      dispatch(fetchClientList());
    }
  }, [clientsList, dispatch]);

  return clientsList;
}
